import * as React from "react";
const SvgFiRrNavigation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-navigation_svg__a)">
      <path
        fill="#062147"
        d="M13.987 6.108c-.039.011-7.228 2.864-7.228 2.864a2.76 2.76 0 0 0 .2 5.212l2.346.587.773 2.524A2.74 2.74 0 0 0 12.617 19h.044a2.74 2.74 0 0 0 2.532-1.786s2.693-7.165 2.7-7.2a3.2 3.2 0 0 0-3.908-3.907zm1.983 3.359-2.648 7.043a.74.74 0 0 1-.692.49c-.1-.012-.525-.026-.675-.378l-.908-2.976a1 1 0 0 0-.713-.679l-2.818-.7a.762.762 0 0 1-.027-1.433l7.06-2.8a1.15 1.15 0 0 1 1.094.32 1.19 1.19 0 0 1 .327 1.113M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 22a10 10 0 1 1 10-10 10.01 10.01 0 0 1-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-navigation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNavigation;
